import { useContext } from 'react'
import { Box } from '@mui/material'
import { ForwardListSearched } from './forward-list-searched'
import { RecentUsers } from './components/recent-users'
import { LastSearchedChats } from './components/last-searched-chats'
import { ForwardSearchQueryContext } from '$comp/_app/components/leftPanel/components/forward-list'
import { useSearchedLocalRooms } from '$logic/room-list/room-list-search.react-hook'
import { useRecentUsersIsEnabled } from '$logic/client-device'

export function ForwardListSearch({
  hasSelection,
  selectionMap,
  onSelectedChange,
  onSelect,
}: {
  hasSelection: boolean
  selectionMap: Record<string, boolean>
  onSelectedChange: (selected: boolean, chatId: string) => unknown
  onSelect: (selectedRoomId: string) => unknown
}) {
  const searchQuery = useContext(ForwardSearchQueryContext)
  const recentUsersIsEnabled = useRecentUsersIsEnabled()
  return searchQuery ? (
    <ForwardListSearched
      query={searchQuery}
      selectionMap={selectionMap}
      hasSelection={hasSelection}
      onSelectedChange={onSelectedChange}
      onSelect={onSelect}
    />
  ) : (
    <Box sx={{ height: '100%', overflow: 'auto' }}>
      {recentUsersIsEnabled && (
        <RecentUsers
          hasSelection={hasSelection}
          onSelectedChange={onSelectedChange}
          onSelect={onSelect}
        />
      )}
      <LastSearchedChats
        selectionMap={selectionMap}
        hasSelection={hasSelection}
        onSelectedChange={onSelectedChange}
        onSelect={onSelect}
      />
    </Box>
  )
}
